import { useMemo } from 'react';
import { usePermissions } from '@helios/auth-firebase-web';
import { isPathAccessible } from './permissionMap';

/**
 * PRD.268 — filter a sidebar nav array to the entries the current user can
 * reach, gated by each item's destination `path` (same source of truth as the
 * route guards). A section whose items all filter out should not render its
 * header — check the returned array's length at the call site.
 */
export function useVisibleNav<T extends { path: string }>(items: readonly T[]): T[] {
  const { canAccess } = usePermissions();
  return useMemo(
    () => items.filter((item) => isPathAccessible(item.path, canAccess)),
    [items, canAccess],
  );
}
